module.exports = {"last_update":"2024-10-03T07:47:40.360Z","api_url":"https://api.agcaddy.com/","ui_url":"https://report.agcaddy.com","key_public":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOiJkYWlzb19wb3MiLCJjcmVhdGUiOiIyMDIwLTEyLTE0IDEyOjQzOjEyIn0.1K9LjN4_hhOP4aOXqHJ3AZwqGS7ghomKA_SDd7S439k"}


//////////////////
// WEBPACK FOOTER
// ./static/config.json
// module id = 194
// module chunks = 83